import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './app/App';
import './ant.css';
import './ant-overrides.css';
import ConfigService from './shared/services/ConfigService';
import {ErrorHandler} from './app/context/ErrorHandler';
import DataService, {FetchOperation} from './shared/services/DataService';
import StackTrace from 'stacktrace-js';
import {isNil} from 'lodash-es';

function isBrowserSupported(): boolean {
  // Denylist IE 10, 9 and 8 based on user agent
  const IE_USER_AGENT_REGEX = /MSIE\s?(\d+)(?:\.(\d+))?/i;

  const matches = navigator.userAgent.match(IE_USER_AGENT_REGEX);
  if (matches != null) {
    if (matches[1] === '10' || matches[1] === '9' || matches[1] === '8') {
      return false;
    }
  }

  return true;
}

function reportError(error: Error, retry: boolean = true) {
  const language = navigator.language;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  StackTrace.fromError(error).then((frames) => {
    const stack = frames.map(f => {
      return f.toString();
    }).join('\n');

    DataService.fetch(
      '/telemetry/report-error',
      {
        errorMessage: error.message,
        stackTrace: stack,
        language: language,
        timeZoneName: timezone
      },
      FetchOperation.Post,
      null,
      null,
      false
    ).then().catch(() => {
      if (!retry) {
        return;
      }

      const TWO_MINUTES = 1000 * 60 * 2;
      window.setTimeout(
        () => {
          try {
            // reportError(error, false);
          } catch {
            // Intentionally do nothing - we tried at least
          }
        },
        TWO_MINUTES
      );
    });
  });
}

function hookErrorHandlers() {
  window.addEventListener(
    'error',
    (e) => {
      if (isNil(e) || isNil(e.error)) {
        return false;
      }

      reportError(e.error);
      return false;
    }
  );
  window.addEventListener(
    'unhandledrejection',
    (e) => {
      if (isNil(e) || isNil(e.reason)) {
        return false;
      }

      if (e.reason instanceof Error) {
        reportError(e.reason);
      } else {
        reportError(new Error(JSON.stringify(e.reason)));
      }
      return false;
    }
  );
}

if (isBrowserSupported()) {
  hookErrorHandlers();
  ConfigService.loadConfig().then(() => {
    ReactDOM.render(
      <ErrorHandler.Provider
        value={{
          reportError: reportError
        }}
      >
        <App/>
      </ErrorHandler.Provider>,
      document.getElementById('root') as HTMLElement
    );
  });
} else {
  (document.getElementById('root') as HTMLElement).innerText = 'Sorry, your browser is not supported';
}
